import { NavLink } from 'react-router-dom';
import { useI18n } from '../../../i18n/useI18n';
import { LiksTooltip } from '../LiksTooltip/LiksTooltip';
import type { LiksSidebarNavItem } from './sidebarNavItems';

export type LiksSidebarNavProps = {
  items: LiksSidebarNavItem[];
  showLabels: boolean;
  showTooltips: boolean;
  onNavLinkClick: () => void;
};

export function LiksSidebarNav({
  items,
  showLabels,
  showTooltips,
  onNavLinkClick,
}: LiksSidebarNavProps) {
  const { translate } = useI18n();

  return (
    <nav className="liks-sidebar__nav">
      <ul className="liks-sidebar__list">
        {items.map((item) => {
          const NavIcon = item.icon;
          return (
            <li key={item.path}>
              <LiksTooltip
                content={showTooltips ? translate(item.labelKey) : undefined}
                placement="right"
                block
              >
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    `liks-sidebar__link${isActive ? ' liks-sidebar__link--active' : ''}`
                  }
                  onClick={onNavLinkClick}
                >
                  <NavIcon
                    className="liks-sidebar__icon"
                    strokeWidth={2}
                    aria-hidden
                  />
                  {showLabels && (
                    <span className="liks-sidebar__label">
                      {translate(item.labelKey)}
                    </span>
                  )}
                </NavLink>
              </LiksTooltip>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
